import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { AppContext } from './../AppContext';
import { UncontrolledTooltip, Table, Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { BsFillFileBarGraphFill, BsChatLeftTextFill, BsFilePdfFill } from 'react-icons/bs';
import { Icon } from "./Icon";
import { Paginacion } from './Paginacion';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

const MySwal = withReactContent(Swal);

//const TITLE = process.env.REACT_APP_TITLE;
const TITLE = "Reportes de Retroalimentación Estudiantil";
const APIURL = process.env.REACT_APP_API_URL;

const dateOptions = {
    year: "2-digit",
    month: "numeric",
    day: "numeric",
};

export class MisParalelos extends Component {
    static displayName = MisParalelos.name;

    constructor(props) {
        super(props);
        this.state = { total: 0, page: 1, size: 10, paralelos: [], loading: true };
        this.handlePage = this.handlePage.bind(this);
        this.handleDetalle = this.handleDetalle.bind(this);
        this.toggle = this.toggle.bind(this);
    }

    componentDidMount() {
        const currentUser = this.context.currentUser;
        document.title = TITLE + " - Histórico por profesor";
        const page = parseInt(this.props.match.params["page"]) || 1;
        const size = parseInt(this.props.match.params["size"]) || 10;

        if (currentUser && currentUser.numeroidentificacion.length > 0) {
            this.populateData(currentUser.numeroidentificacion, page, size);
        }

    }

    componentDidUpdate() {
        const currentUser = this.context.currentUser;
        const page = parseInt(this.props.match.params["page"]) || 1;
        const size = parseInt(this.props.match.params["size"]) || 10;

        if (currentUser && currentUser.numeroidentificacion.length > 0) {
            this.populateData(currentUser.numeroidentificacion, page, size);
        }
    }

    handlePage(url, page, size) {
        this.props.history.push(`${url}/${page}/${size}`);
    }

    handleDetalle(anio, termino, codigo, paralelo, identificacion) {
        this.props.history.push(`/paralelo/${anio}/${termino}/${codigo}/${paralelo}/${identificacion}`);
    }

    toggle(paralelo) {
        const i = this.state.paralelos.indexOf(paralelo);

        if (!paralelo.verpdf) {
            MySwal.fire({
                title: 'Cargando Reporte...',
                allowOutsideClick: false,
                showConfirmButton: false,
                onBeforeOpen: () => {
                    MySwal.showLoading();
                },
            });

            let url = paralelo.codigo !== 'PRASC' && paralelo.codigo !== 'PRAEM' ?
                `${APIURL}/api/reporte-usuario/reporte-general-pdf/${paralelo.sistema}/${paralelo.idcurso}/${paralelo.idpersona}` :
                `${APIURL}/api/reporte-usuario/reporte-practica-pdf/${paralelo.anio}/${paralelo.codigo}/${paralelo.idpersona}`;

            fetch(url)
                .then(response => response.json())
                .then(data => {
                    this.setState(({ paralelos }) => ({
                        paralelos: [
                            ...paralelos.slice(0, i),
                            {
                                ...paralelos[i],
                                verpdf: !paralelos[i].verpdf,
                                datapdf: data
                            },
                            ...paralelos.slice(i + 1)
                        ]
                    }));
                    MySwal.close();
                })
                .catch(error => {
                    console.error('Error al cargar el reporte:', error);
                    MySwal.fire('Error', 'No se pudo cargar el PDF.', 'error');
                });
        }
        else {
            this.setState(({ paralelos }) => ({
                paralelos: [
                    ...paralelos.slice(0, i),
                    {
                        ...paralelos[i],
                        verpdf: !paralelos[i].verpdf,
                    },
                    ...paralelos.slice(i + 1)
                ]
            }));
        }
    }

    formatter(valor) {
        return new Intl.NumberFormat('en-US', { minimumFractionDigits: '2', maximumFractionDigits: '2', signDisplay: 'never' }).format(valor)
    }

    renderTable(currentUser, paralelos) {
        //console.log(currentUser); console.log(paralelos);
        return (
            <Table responsive={true} striped={true}>
                <thead>
                    <tr>
                        <th className="text-center col-1" scope="col">Año</th>
                        <th className="text-center col-1" scope="col">Término</th>
                        <th className="text-center col-1" scope="col">Nivel</th>
                        <th className="text-center col-1" scope="col">Código</th>
                        <th className="text-center col-3" scope="col">Curso / Actividad</th>
                        <th className="text-center col-1" scope="col">Paralelo</th>
                        <th className="text-center col-1" scope="col">% Respuestas</th>
                        <th className="text-center col-1" scope="col">Calificación</th>
                        <th className="text-center col-1" scope="col">
                            <span id="tt-fp">Fecha publicación</span>
                            <UncontrolledTooltip placement="top" target="tt-fp">
                                {"día / mes / año"}
                            </UncontrolledTooltip>
                        </th>
                        <th className="col-1" scope="col">{' '}</th>
                    </tr>
                </thead>
                <tbody>
                    {paralelos.map((p, index) => {
                        const porcentaje = Math.round(p.evaluados * 100 / p.registrados);
                        return (
                            <tr key={index}>
                                <td className="text-center">{p.anio}</td>
                                <td className="text-center">{p.termino ? p.termino : 'N/A'}</td>
                                <td className="text-center">{p.nivel}</td>
                                <td className="text-center">{p.codigo}</td>
                                <td>{p.codigo !== 'PRASC' && p.codigo !== 'PRAEM' ? p.materia : p.codigo === "PRAEM" ? "Tutoría de prácticas empresariales" : "Tutoría de prácticas de servicio comunitario"}</td>
                                <td className="text-center">{p.paralelo ? p.paralelo : 'N/A'}</td>
                                <td className="text-center">
                                    <span id={"tt_" + index} >{porcentaje}%</span>
                                    <UncontrolledTooltip placement="right" target={"tt_" + index}>
                                        {p.evaluados}/{p.registrados}
                                    </UncontrolledTooltip>
                                </td>
                                <td className="text-center">{p.evaluados > 0 ? this.formatter(p.promedio) : "-"}</td>
                                <td className="text-center">{p.fechapublicacion ? new Date(p.fechapublicacion).toLocaleString('es-EC', dateOptions) : "-"}</td>
                                <td>
                                    <div className="btn-group" role="group" aria-label="Opciones">

                                        <span id={"ttb_" + index}>
                                            {p.codigo !== 'PRASC' && p.codigo !== 'PRAEM' ? (
                                                <Link className="btn btn-secondary" to={`/paralelo/${p.anio}/${p.termino}/${p.codigo}/${p.paralelo}/${p.cedula}`}>
                                                    <Icon icon={<BsFillFileBarGraphFill />} />
                                                </Link>
                                            ) : (
                                                <Link className="btn btn-secondary" to={`/practica/${p.anio}/${p.codigo}/${p.cedula}`}>
                                                    <Icon icon={<BsFillFileBarGraphFill />} />
                                                </Link>
                                            )}
                                        </span>
                                        <UncontrolledTooltip placement="top" target={"ttb_" + index}>
                                            {"Detalle"}
                                        </UncontrolledTooltip>

                                        <span id={"ttb_pdf_" + index}>
                                            <Link className="btn btn-secondary" to="#" onClick={() => this.toggle(p)}>
                                                <Icon icon={<BsFilePdfFill />} />
                                            </Link>
                                        </span>
                                        <UncontrolledTooltip placement="top" target={"ttb_pdf_" + index}>
                                            {"Detalle en PDF"}
                                        </UncontrolledTooltip>
                                        {currentUser && currentUser.numeroidentificacion == p.cedula &&
                                            <>
                                                <Modal isOpen={p.verpdf} className="modal-xl">
                                                    <ModalHeader>{p.codigo !== 'PRASC' && p.codigo !== 'PRAEM' ? 'Detalle Paralelo' : 'Detalle Tutor'}</ModalHeader>
                                                    <ModalBody>
                                                        <embed src={`data:application/pdf;base64,${p.datapdf}`} width={1100} height={600} type='application/pdf' pluginspage="http://www.adobe.com/products/acrobat/readstep2.html" />
                                                    </ModalBody>
                                                    <ModalFooter>
                                                        <Button color="secondary" onClick={() => this.toggle(p)}>Cerrar</Button>
                                                    </ModalFooter>
                                                </Modal>

                                                <span id={"ttc_" + index}>
                                                    {p.codigo !== 'PRASC' && p.codigo !== 'PRAEM' ? (
                                                        <Link className="btn btn-secondary" to={`/paralelo-comentarios/${p.anio}/${p.termino}/${p.codigo}/${p.paralelo}/${p.cedula}/${p.idnivelformacion}`}>
                                                            <Icon icon={<BsChatLeftTextFill />} />
                                                        </Link>
                                                    ) : (
                                                        <Link className="btn btn-secondary" to={`/practica-comentarios/${p.anio}/${p.codigo}/${p.cedula}`}>
                                                            <Icon icon={<BsChatLeftTextFill />} />
                                                        </Link>
                                                    )}
                                                </span>
                                                <UncontrolledTooltip placement="top" target={"ttc_" + index}>
                                                    {"Comentario"}
                                                </UncontrolledTooltip>
                                            </>
                                        }
                                    </div>
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
                <tfoot>
                    <tr>
                        <td colSpan={10}>
                            <Paginacion total={this.state.total} page={this.state.page} size={this.state.size} url={`/mis-paralelos`} handle={this.handlePage} />
                        </td>
                    </tr>
                </tfoot>
            </Table>
        );
    }

    render() {
        const currentUser = this.context.currentUser;
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderTable(currentUser, this.state.paralelos);

        return (
            <div>
                {currentUser && currentUser.usuario && currentUser.roles && currentUser.roles.some(r => r.role === "TUTOR") && (
                    <div className="alert alert-info" role="alert">
                        Los resultados de la heteroevaluación para las actividades de Tutorías de prácticas preprofesionales empresariales y de servicio comunitario estarán disponibles a partir del 18 de marzo, fecha de cierre del período de evaluación.
                    </div>
                )}
                <h1 id="tabelLabel">Mis actividades de docencia</h1>
                {contents}
            </div>
        );
    }

    async populateData(identificacion, page = 1, size = 10) {
        //console.log("paralelos = " + this.state.paralelos.length + " page = " + page + " page_state = " + this.state.page);
        if (this.state.paralelos != 0 && page == this.state.page) return;
        const response = await fetch(`${APIURL}/api/reportes/paralelos-profesor/${identificacion}/${page}/${size}`);
        const data = await response.json();

        if (data && data.total && data.datos) {
            const paralelos = data.datos.map(p => ({ ...p, verpdf: false, datapdf: "" }));

            this.setState({ total: data.total, page: page, size: size, paralelos: paralelos, loading: false });
        }
    }
}
MisParalelos.contextType = AppContext;